// extracted by mini-css-extract-plugin
export var root = "MarkdownEm-module--root--9eb06";